export default {
  usePropTips: '/prop/client/usePropSettingTips',
  selectDestinationPoi: '/v3/gps/selectDestinationPoi',
  submit: '/v3/backTrip/set'
}
